import React from 'react'
import styled from 'styled-components'

import useWindowSize from '~/components/hooks/use-window-size'
import withThemeAndStoreHoC from '~/components/with-theme-and-store'
import { LARGE_LAYOUT_THRESHOLD } from '~/core/constants'
import { translate } from '~/core/translate'

const Container = styled.div`
  background-color: ${props => props.theme._neo.ui06};
  color: ${props => props.theme.color};
  display: flex;
  height: 100%;
  text-align: center;
  width: 100%;
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  margin: auto;
  padding: 0 16px;
`

const Title = styled.h1`
  max-width: 500px;
  margin: 0 auto;
  font-weight: 600;
  font-size: 32px;
  line-height: 40px;
  text-align: center;
  letter-spacing: -0.02em;

  @media (max-width: ${LARGE_LAYOUT_THRESHOLD}px) {
    font-size: 28px;
    line-height: 36px;
    letter-spacing: -0.015em;
  }
`

const Description = styled.p`
  max-width: 500px;
  background-color: ${props => props.theme._neo.ui02};
  border-radius: 8px;
  font-weight: normal;
  font-size: 16px;
  line-height: 26px;
  text-align: center;
  margin: 40px auto 0 auto;
  padding: 15px 16px;
`

const Unauthorized = () => {
  useWindowSize()

  return (
    <Container>
      <Content>
        <Title>{translate('unauthorized_meeting_properties_title')}</Title>
        <Description>{translate('unauthorized_meeting_properties_description')}</Description>
      </Content>
    </Container>
  )
}

export default withThemeAndStoreHoC(Unauthorized)
